// extracted by mini-css-extract-plugin
export var addToCartButton = "_tm-b";
export var arrowButtonContainer = "_tm-9";
export var arrowButtonIcon = "_tm-a";
export var carouselArrowButton = "_tm-6";
export var carouselElementContainer = "_tm-1";
export var left = "_tm-7";
export var productDisplayCarouselContainer = "_tm-0";
export var productTileContainer = "_tm-2";
export var productTileImage = "_tm-4";
export var productTileImageContainer = "_tm-3";
export var productTileTitle = "_tm-5";
export var right = "_tm-8";
export var sliderOverflow = "_tm-c";